import React from 'react';

// Floral Ornamental Pattern
export const FloralPattern = ({ className = '' }) => (
  <svg
    className={className}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <defs>
      <pattern id="floral" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
        <path
          d="M50,20 Q60,30 65,40 Q70,50 65,60 Q60,70 50,80 Q40,70 35,60 Q30,50 35,40 Q40,30 50,20 Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.5"
          opacity="0.3"
        />
        <circle cx="50" cy="50" r="3" fill="currentColor" opacity="0.2" />
        <path
          d="M20,50 Q30,40 40,35 Q50,30 60,35 Q70,40 80,50 Q70,60 60,65 Q50,70 40,65 Q30,60 20,50 Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="0.5"
          opacity="0.2"
        />
      </pattern>
    </defs>
    <rect width="100" height="100" fill="url(#floral)" />
  </svg>
);

// Vintage Frame Border
export const VintageFrame = ({ children, className = '' }) => (
  <div className={`relative ${className}`}>
    {/* Corner decorations */}
    <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-terracotta/40" />
    <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-terracotta/40" />
    <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-terracotta/40" />
    <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-terracotta/40" />
    
    {/* Content */}
    <div className="p-4">{children}</div>
    
    {/* Decorative lines */}
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute top-8 left-0 right-0 h-px bg-gradient-to-r from-transparent via-terracotta/20 to-transparent" />
      <div className="absolute bottom-8 left-0 right-0 h-px bg-gradient-to-r from-transparent via-terracotta/20 to-transparent" />
      <div className="absolute left-8 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-terracotta/20 to-transparent" />
      <div className="absolute right-8 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-terracotta/20 to-transparent" />
    </div>
  </div>
);

// Hand-drawn style divider
export const HandDrawnDivider = ({ className = '' }) => (
  <div className={`flex items-center justify-center my-12 ${className}`}>
    <svg
      className="w-32 h-8 text-terracotta/40"
      viewBox="0 0 200 40"
      preserveAspectRatio="none"
    >
      <path
        d="M10,20 Q50,10 100,20 T190,20"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        vectorEffect="non-scaling-stroke"
      />
      <circle cx="100" cy="20" r="3" fill="currentColor" />
    </svg>
  </div>
);

// Ornamental corner
export const OrnamentalCorner = ({ position = 'top-left', className = '' }) => {
  const positions = {
    'top-left': 'top-0 left-0',
    'top-right': 'top-0 right-0',
    'bottom-left': 'bottom-0 left-0',
    'bottom-right': 'bottom-0 right-0',
  };

  return (
    <div className={`absolute ${positions[position]} w-16 h-16 ${className}`}>
      <svg
        viewBox="0 0 64 64"
        className="w-full h-full text-terracotta/30"
        fill="currentColor"
      >
        <path d="M32,0 Q48,8 56,24 Q64,40 56,56 Q48,64 32,56 Q16,64 8,56 Q0,40 8,24 Q16,8 32,0 Z" />
      </svg>
    </div>
  );
};

// Decorative flourish
export const DecorativeFlourish = ({ className = '' }) => (
  <div className={`flex justify-center items-center ${className}`}>
    <svg
      className="w-24 h-8 text-terracotta/30"
      viewBox="0 0 200 40"
      preserveAspectRatio="none"
    >
      <path
        d="M20,20 Q40,10 60,20 Q80,30 100,20 Q120,10 140,20 Q160,30 180,20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="100" cy="20" r="2" fill="currentColor" />
    </svg>
  </div>
);

export default {
  FloralPattern,
  VintageFrame,
  HandDrawnDivider,
  OrnamentalCorner,
  DecorativeFlourish,
};
